<template>
<div :class="classes" :style="{ height: height + 'px' }" class="progress-linear">
  <div :style="styles" class="progress-linear__bar">
    <n-fade-transition>
      <div v-if="indeterminate" class="progress-linear__bar__indeterminate"></div>
    </n-fade-transition>
    <n-slide-x-transition>
      <div :style="{ width: value + '%' }" v-if="!indeterminate" class="progress-linear__bar__determinate"></div>
    </n-slide-x-transition>
  </div>
</div>
</template>

<script>
  import Contextualable from '../../mixins/contextualable'

  export default {

    mixins: [Contextualable],

    props: {
      active: {
        type: Boolean,
        default: true
      },

      buffer: Boolean,

      bufferValue: Number,

      height: {
        type: [Number, String],
        default: 7
      },

      indeterminate: Boolean,

      value: {
        type: [Number, String],
        default: 0
      }
    },

    computed: {
      classes () {
        return {
          'progress-linear--secondary': this.secondary,
          'progress-linear--success': this.success,
          'progress-linear--info': this.info,
          'progress-linear--warning': this.warning,
          'progress-linear--error': this.error
        }
      },

      styles () {
        const styles = {}

        if (!this.active) {
          styles.height = 0
        }

        if (this.buffer) {
          styles.width = `${this.bufferValue}%`
        }

        return styles
      },

      bufferStyles () {
        const styles = {}

        if (!this.active) {
          styles.height = 0
        }

        return styles
      }
    }
  }
</script>